'use client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import React from 'react';

import { ParticleProvider } from './wallet/providers/particle';

const client = new QueryClient({ defaultOptions: { queries: { staleTime: 5000 } } });

export function Providers({ children }: React.PropsWithChildren) {
  return (
    <QueryClientProvider client={client}>
      <ParticleProvider>{children}</ParticleProvider>
    </QueryClientProvider>
  );
}
